import CTA from "../components/CTA/CTA";
import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import HeroOne from "../components/HeroOne/HeroOne";
import Price from "../components/prices/Price";
import SEOHead from "../components/SEOHead/SEOHead";
import { useLanguage } from "../contexts/LanguageContext";

import "./HomePage.css";

const HomePage = () => {
  const { translations } = useLanguage();
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "Snappin",
    description: translations?.seo?.homepage?.description,
    url: window.location.origin,
    applicationCategory: "PhotographyApplication",
    operatingSystem: "Web",
  };

  return (
    <div className="home-page">
      <SEOHead title={translations?.seo?.homepage?.title} description={translations?.seo?.homepage?.description} type="website" schema={schema} />
      <Header />
      <HeroOne />
      <Price />
      <CTA />
      <Footer />
    </div>
  );
};

export default HomePage;
